/* REVELASHION — sélecteur de variantes de la page produit.
   Un swatch cliqué recalcule la variante correspondante à partir des
   vraies données Shopify (JSON injecté par le thème), puis met à jour
   le prix, le bouton, la variante du formulaire et fait défiler la
   galerie jusqu'à l'image associée à cette variante. */
(() => {
  const root = document.querySelector('[data-product-main]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  let variants = [];
  try {
    const el = document.getElementById(root.dataset.variantsJson);
    variants = el ? JSON.parse(el.textContent) : [];
  } catch (e) {
    variants = [];
  }

  const optionCount = Number(root.dataset.optionCount || 0);
  const selected = new Array(optionCount).fill(null);

  root.querySelectorAll('[data-option-row]').forEach((row) => {
    const idx = Number(row.dataset.optionRow) - 1;
    const active = row.querySelector('.pp-swatch.is-selected') || row.querySelector('.pp-swatch');
    if (active) selected[idx] = active.dataset.value;
  });

  const priceEl = root.querySelector('[data-product-price]');
  const idInput = root.querySelector('[data-product-id-input]');
  const submitBtn = root.querySelector('[data-product-submit]');
  const submitLabel = submitBtn ? submitBtn.querySelector('[data-btn-label]') : null;
  const gallery = root.querySelector('[data-product-gallery]');

  const findVariant = () => variants.find((v) =>
    v.options.every((opt, i) => selected[i] == null || opt === selected[i])
  );

  /* Amène la galerie sur l'image de la variante choisie.

     Deux pièges évités ici. `offsetLeft` se compte depuis le premier
     ancêtre positionné et change avec le défilement en cours : on mesure
     donc l'écart réel à l'écran. Et l'événement `hs:refresh` que l'on
     émettait ensuite remet le carrousel à zéro — il annulait le
     défilement qui venait d'être lancé. */
  const goToMedia = (mediaId) => {
    if (!gallery || !mediaId) return;
    const slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    const delta = slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
    if (Math.abs(delta) < 2) return;
    gallery.scrollTo({ left: gallery.scrollLeft + delta, behavior: 'smooth' });
  };

  /* Shopify ne rattache qu'une image à chaque variante ; le reste des
     médias est commun au produit. On ne garde donc que l'image de la
     variante choisie et les médias communs : sans ce filtre, on défilait
     jusqu'aux photos des autres coloris.

     Les diapos écartées sont masquées, pas retirées : changer de variante
     ne coûte alors aucune requête. */
  const filterGallery = (variantId) => {
    if (!gallery) return;
    gallery.querySelectorAll('[data-media-id]').forEach((slide) => {
      const owner = slide.dataset.variantMedia;
      const mine = String(owner) === String(variantId);
      slide.hidden = !(!owner || mine);
      /* L'image de la variante passe en tête par `order` plutôt que par
         un déplacement dans le DOM : aucune image n'est réinsérée, donc
         aucune n'est rechargée. */
      slide.style.order = mine ? '-1' : '';
    });
    /* La largeur utile vient de changer : on repart du début, sur l'image
       de la variante. */
    gallery.scrollLeft = 0;
  };

  const applyVariant = () => {
    root.querySelectorAll('[data-option-row]').forEach((row) => {
      const idx = Number(row.dataset.optionRow) - 1;
      row.querySelectorAll('.pp-swatch').forEach((btn) => {
        const on = btn.dataset.value === selected[idx];
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', String(on));
      });
    });

    const variant = findVariant();

    if (!variant) {
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = root.dataset.unavailableLabel || 'Indisponible';
      return;
    }

    /* variant.price est le résultat du filtre Liquid `money`, qui peut
       contenir du HTML (ex. apps de devise comme Transcy) : on l'injecte
       donc en innerHTML, jamais en textContent, pour qu'il soit rendu
       et non affiché comme du texte brut. */
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.innerHTML = variant.price;
    if (submitBtn) submitBtn.disabled = !variant.available;
    /* Précommande : la date d'envoi n'accompagne la ligne du panier que
       pour une variante en précommande. */
    const preInput = root.querySelector('[data-preorder-input]');
    const preNote = root.querySelector('[data-preorder-note]');
    const preDate = root.querySelector('[data-preorder-date]');
    if (preInput) {
      preInput.disabled = !variant.preorder;
      if (variant.preorder) preInput.value = variant.preorder;
    }
    if (preNote) preNote.hidden = !variant.preorder;
    if (preDate && variant.preorder) preDate.textContent = variant.preorder;
    if (submitLabel) {
      const label = !variant.available
        ? (root.dataset.soldOutLabel || 'Épuisé')
        : variant.preorder
          ? (root.dataset.preorderLabel || 'Précommander')
          : (root.dataset.addLabel || 'Ajouter au panier');
      submitLabel.innerHTML = label + ' — ' + variant.price;
    }
    /* Les tarifs d'abonnement suivent la variante : sans cela, changer de
       coloris laissait la carte d'abonnement au prix du coloris précédent,
       et le bouton annonçait un montant que le panier ne pratiquait pas.
       Le module des formules vit dans une autre portée ; on le prévient
       par un événement plutôt que par une variable partagée. */
    root.dispatchEvent(new CustomEvent('pdp:variant', { detail: variant }));

    /* L'ordre compte : on filtre d'abord, sinon le défilement viserait une
       position calculée sur une galerie qui va changer de largeur. */
    filterGallery(variant.id);
    if (variant.mediaId) goToMedia(variant.mediaId);
  };

  root.querySelectorAll('[data-option-row]').forEach((row) => {
    const idx = Number(row.dataset.optionRow) - 1;
    row.querySelectorAll('.pp-swatch').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.dataset.value === selected[idx]) return;
        selected[idx] = btn.dataset.value;
        applyVariant();
      });
    });
  });

  applyVariant();
})();

/* REVELASHION — bloc d'achat : promesse tournante, décompte de livraison,
   formule d'achat. Le sélecteur de variantes reste géré plus haut. */
(() => {
  const pdp = document.querySelector('.pdp');
  if (!pdp || pdp.dataset.buyReady) return;
  pdp.dataset.buyReady = '1';

  /* --- Promesse tournante --- */
  const promise = pdp.querySelector('[data-promise]');
  if (promise) {
    const items = promise.querySelectorAll('.pdp__promise__item');
    const dots = promise.querySelectorAll('.pdp__promise__dots span');
    if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let i = 0;
      setInterval(() => {
        i = (i + 1) % items.length;
        items.forEach((el, n) => el.classList.toggle('on', n === i));
        dots.forEach((el, n) => el.classList.toggle('on', n === i));
      }, 4200);
    }
  }

  /* --- Décompte de livraison ---
     Le message est un gabarit : [compte] devient le temps restant avant
     l'heure limite d'expédition, [date] la date de réception estimée.
     Tout est calculé chez le visiteur, donc dans SON fuseau — une valeur
     rendue côté serveur aurait été fausse pour la moitié des visiteurs. */
  const delivery = pdp.querySelector('[data-delivery]');
  if (delivery) {
    const template = delivery.textContent.trim();
    const cutoff = Number(delivery.dataset.cutoff || 14);
    const lead = Number(delivery.dataset.lead || 3);
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

    const tick = () => {
      const now = new Date();
      const limit = new Date(now);
      limit.setHours(cutoff, 0, 0, 0);

      /* Passé l'heure limite, la commande part le lendemain : le délai
         de livraison court alors depuis J+1. */
      let extra = 0;
      if (now >= limit) {
        limit.setDate(limit.getDate() + 1);
        extra = 1;
      }

      const left = limit - now;
      const h = Math.floor(left / 3600000);
      const m = Math.floor((left % 3600000) / 60000);

      const eta = new Date(now);
      eta.setDate(eta.getDate() + lead + extra);

      delivery.innerHTML = template
        .replace('[compte]', '<b>' + h + ' h ' + m + ' min</b>')
        .replace('[date]', '<b>' + fmt.format(eta) + '</b>');
    };

    tick();
    setInterval(tick, 60000);
  }

  /* --- Formule d'achat ---
     Le bouton annonce le montant réellement débité : sur un abonnement,
     celui du plan, pas celui de l'achat unique. */
  const label = pdp.querySelector('[data-btn-label]');
  const addLabel = pdp.dataset.addLabel || 'Ajouter au panier';
  const subRadio = pdp.querySelector('[data-plan-sub]');
  const planPrice = pdp.querySelector('[data-plan-price]');
  const planOff = pdp.querySelector('[data-plan-off]');
  const freq = pdp.querySelector('[data-plan-freq]');

  const majBouton = () => {
    const coche = pdp.querySelector('input[name="selling_plan"]:checked');
    const carte = coche && coche.closest('.pdp__plan');
    const prix = carte && carte.querySelector('.pdp__plan__price');
    if (!label || !prix) return;
    /* Le prix barré ne doit pas se retrouver sur le bouton. */
    const clone = prix.cloneNode(true);
    clone.querySelectorAll('s').forEach((el) => el.remove());
    const pre = pdp.querySelector('[data-preorder-input]:not([disabled])');
    const texte = pre ? (pdp.dataset.preorderLabel || 'Précommander') : addLabel;
    label.textContent = texte + ' · ' + clone.textContent.trim();
  };

  /* Écrit un montant dans la carte d'abonnement, prix barré compris. */
  const poseePrix = (prix, barre) => {
    if (!planPrice) return;
    planPrice.innerHTML = (barre ? '<s>' + barre + '</s>' : '') + prix;
  };

  pdp.querySelectorAll('input[name="selling_plan"]').forEach((radio) => {
    radio.addEventListener('change', majBouton);
  });

  /* La fréquence n'est pas un champ envoyé : elle réécrit la valeur du
     bouton radio de l'abonnement. Deux champs nommés `selling_plan`
     partiraient ensemble au panier, et Shopify n'en retiendrait qu'un. */
  if (freq && subRadio) {
    freq.addEventListener('change', () => {
      const opt = freq.options[freq.selectedIndex];
      subRadio.value = opt.value;
      poseePrix(opt.dataset.price || '', opt.dataset.compare || '');
      subRadio.checked = true;
      majBouton();
    });
  }

  /* Au changement de variante : les allocations de plan sont portées par la
     variante, pas par le produit. */
  pdp.addEventListener('pdp:variant', (e) => {
    const variant = e.detail;
    if (!variant || !Array.isArray(variant.plans) || !variant.plans.length) return;

    if (freq) {
      Array.from(freq.options).forEach((opt) => {
        const p = variant.plans.find((x) => String(x.id) === opt.value);
        if (!p) return;
        opt.dataset.price = p.price;
        opt.dataset.compare = p.compare || '';
      });
    }

    const vise = subRadio ? subRadio.value : '';
    const p = variant.plans.find((x) => String(x.id) === vise) || variant.plans[0];
    if (!p) return;
    if (subRadio) subRadio.value = p.id;
    poseePrix(p.price, p.compare || '');

    if (planOff && p.compare) {
      /* La remise est recalculée depuis les deux montants affichés plutôt
         que recopiée : sur certaines variantes elle n'est pas la même. */
      const n = (v) => parseFloat(String(v).replace(/[^0-9,.-]/g, '').replace(',', '.')) || 0;
      const plein = n(p.compare);
      const remise = plein ? Math.round(((plein - n(p.price)) / plein) * 100) : 0;
      planOff.hidden = remise <= 0;
      if (remise > 0) planOff.innerHTML = '&minus;' + remise + '&nbsp;%';
    }
    majBouton();
  });
})();
